export default "__VITE_ASSET__Bivc2Ovl__"